/* eslint-disable no-unused-vars */
export enum VISIBILITY {
  INTERNAL = 'internal',
  PRIVATE = 'private',
  PUBLIC = 'public'
}

export enum SORTBY {
  ASC = 'asc',
  DESC = 'desc'
}

// @ts-nocheck
export enum TIMESORT {
  CREATED_ASC = 'created_asc',
  CREATED_DESC = 'created_desc',
  UPDATED_ASC = 'updated_asc',
  UPDATED_DESC = 'updated_desc'
}

export enum RESOLVE_MODE {
  INTERACTIVE = 'interactive',
  EDIT = 'edit'
}

export enum BRANCH_UPDATE_MESSAGE {
  SOURCE_BRANCH_UPDATED_EN = 'Resolve conflict failed. A new commit in the source branch',
  TARGET_BRANCH_UPDATED_EN = 'Resolve conflict failed. A new commit in the target branch',
  SOURCE_BRANCH_UPDATED_CN = '解决冲突失败，目标分支存在新的提交。',
  TARGET_BRANCH_UPDATED_CN = '解决冲突失败，源分支存在新的提交。',
}

export enum repoTypeEnum {
  /** 代码仓 */
  NORMAL = '0',
  /** 模型仓 */
  MODEL = '1',
  /** 数据集仓 */
  DATASET = '2',
  /** SPACE */
  SPACE = '3'
}

// 上传附件类型
export enum ATTACHMENT_TYPE {
  ISSUE = 'ISSUE', // 创建issue，编辑issue
  ISSUE_COMMENT = 'ISSUE_COMMENT', // 引用回复，评论issue
  PR = 'PR', // 创建pr，编辑pr
  PR_COMMENT = 'PR_COMMENT', // 引用回复，评论pr
  DISCUSSION = 'DISCUSSION', // 创建讨论，编辑讨论
  DISCUSSION_COMMENT = 'DISCUSSION_COMMENT' // 引用回复，评论讨论
}

/** auth授权类型 */
export enum AuthTypeEnum {
  CSDN = 'csdn',
  GITEE = 'gitee',
  GITHUB = 'github',
  HUAWEI = 'huawei',
  WECHAT_OPEN = 'wechat_open',
  WECHAT_MP = 'wechat_mp',
  H_BUILDER = 'hbuilder',
  H_BUILDER_PLUGIN = 'hbuilder_plugins',
  ATOMGIT = 'atomgit',
  PHONE_AND_PASSWORD = 'phoneAndPassword',
}

// 登录方式
export enum LoginMethodEnum {
  PHONE = 'phone',
  PASSWORD = 'password',
  MINI_PROGRAM = 'miniProgram',
  HARMONY = 'harmony',
  CSDN = 'csdn',
  ATOMGIT = 'atomgit',
  GITEE = 'gitee',
  GITHUB = 'github',
  HUAWEI = 'huawei',
  WECHAT_OPEN = 'wechat_open',
  WECHAT_MP = 'wechat_mp',
  H_BUILDER = 'hbuilder',
  H_BUILDER_PLUGIN = 'hbuilder_plugins',
}

export type OtherLoginType = AuthTypeEnum.GITHUB | AuthTypeEnum.GITEE | AuthTypeEnum.H_BUILDER | AuthTypeEnum.HUAWEI;

/** 登录的触发类型 */
export type TriggerType = '主动注册' | '关注组织' | '关注用户' | '关注用户' | string;

// 三方登录的类型
export type AuthType = 'csdn' | 'gitee' | 'github' | 'wechat_open' | 'wechat_mp' | 'hbuilder'

// gitCode绑定状态的类型
export type TBindStatusEnum = 'UNBIND_AND_MATCH' | 'UNBIND_AND_EXIST' | 'UN_REGISTER' | 'IAM_UNINITIALIZED' | 'SUCCESS'

/** 授权状态 */
export enum AuthResType {
  SUCCESS = 'success',
  FAIL = 'fail',
  CANCEL = 'cancel',
}

/** 第三方绑定状态 */
export enum BindStatusEnum {
  UN_REGISTER = 'UN_REGISTER', // 未注册
  UNBIND_AND_MATCH = 'UNBIND_AND_MATCH', // 绑定
  UNBIND_AND_EXIST = 'UNBIND_AND_EXIST', // 换绑
  IAM_UNINITIALIZED = 'IAM_UNINITIALIZED', // 底座报错
  SUCCESS = 'SUCCESS', // 可直接登录
  UN_REGISTER_AND_MIRROR = 'UN_REGISTER_AND_MIRROR',
  BIND_FREEZE_AND_MATCH = 'BIND_FREEZE_AND_MATCH', // 手机号命中迁移预创建账号
}

export enum REPO_EVENT {
	CLICK = 'PC_PageClick',
  SHOW = 'PC_PageShow',
  STAY = 'page_stay'
}

export enum REPO_MODULE {
  SEARCH_SUGGESTION_CARD = '搜索联想卡片',
  SEARCH_RECOMMEND_CARD = '搜索推荐卡片',
  SEARCH_BAR_CLICK = '搜索框点击',
  SEARCH_BAR_EXPO = '搜索框曝光',
  REPO = '搜索结果_项目',
  MODEL = '搜索结果_模型',
  DATASET = '搜索结果_数据集',
  TOPIC = 'topic',
  TAG = '搜索结果_标签',
  ISSUE = '搜索结果_issue',
  PULLREQUEST = '搜索结果_pr',
  GROUP = '搜索结果_组织',
  USER = '搜索结果_用户',
  COMMIT = '搜索结果_commit',
  REPO_HOME = '项目首页',
  REPO_HOME_BREAKBAR = '侧边栏按钮',
  REPO_HOME_SIDEBAR_EXPO = '侧边栏曝光',
  REPO_HOME_OVERLAY = '首页浮窗',
  REPO_HOME_OVERLAY_TODAY = '首页浮窗_今日热门',
  REPO_HOME_OVERLAY_STAR = '首页浮窗_Star飙升',
  REPO_HOME_OVERLAY_DOWNLOAD = '首页浮窗_下载热度',
  REPO_HOME_OVERLAY_DASHBOARD = '首页浮窗_去首页',
  REPO_HOME_OVERLAY_DOWNLOAD_DASHBOARD = '下载推荐浮窗_去首页',
  REPO_OVERLAY_DOWNLOAD_DASHBOARD = '下载推荐浮窗',
  SEARCH_RESULT_OVERLAY = '搜索结果页运营位_曝光',
  SEARCH_RESULT_CLICK = '搜索结果页运营位_点击',
  REPO_HEADER_DOWNLOAD_EXPO = '下载推荐浮窗曝光',
}

// 标签类型
export enum TOPIC_TYPE {
  OPERATION = 0, // 运营标签
  USER = 1 // 用户标签
}

export enum REPO_TYPE {
  GITCODE = 0, // gitcode项目
  GITHUB_MIRRORS = 1, // github镜像
  HUGGINGFACE_MIRRORS = 2 // huggingface镜像
}

export enum CARD_TYPE {
  REPO = 'repo',
  MODEL = 'model',
  DATASET = 'dataset',
  TAG = 'tag',
  ISSUE = 'issue',
  PULLREQUEST = 'pullrequest',
  GROUP = 'group',
  USER = 'user',
  COMMIT = 'commit'
}

export enum PAGE_PARAMS_SOURCE_MODULE {
  SEARCH_RECOMMEND = 'search_recommend', // 搜索结果页的推荐位
  SEARCH_NORESULT_RECOMMEND_DATASET = 'search_noresult_recommend_dataset', // 搜索无结果页的「数据集」
  SEARCH_NORESULT_RECOMMEND_MODEL = 'search_noresult_recommend_model', // 搜索无结果页的「模型」
  HOME_SIDEBAR_AI_COMMUNITY = 'home_sidebar_ai_community', // 首页侧边栏「AI社区」
  SEARCH_RESULT_MODEL = 'search_result_model', // 搜索结果页的「模型」
  SEARCH_RESULT_DATASET = 'search_result_dataset', // 搜索结果页的「数据集」
  HOME_HOT_SELECTION = 'home_hot_selection', // 首页「今日热门」
  SEARCH_BOX_HOT_WORD = 'search_box_hot_word', // 搜索框「热门搜索词」
  SEARCH_BOX_DISCOVERY = 'search_box_discovery', // 搜索框「发现」
  HOME_MAIN_TABS = 'home_main_tabs_', // 首页「tab」
}

// 1 用户标签 0 运营标签
export enum TOPIC_TYPE {
	USER_TOPIC = 1,
	OPERATOR_TOPIC = 0,
}
